import { WeatherDTO } from '../dto/weather/weather.dto';

export class WeatherForecast {
  temperatureMin: number;
  temperatureMax: number;
  weatherCode: number;

  constructor(weatherDTO: WeatherDTO) {
    this.temperatureMin = weatherDTO.main.temp_min;
    this.temperatureMax = weatherDTO.main.temp_max;
    this.weatherCode = weatherDTO.weather[0].id;
  }
}
